import createAxiosInstance from '@/utils/requset'

const apiInstances = {
    api1: createAxiosInstance('api1'),
    api2: createAxiosInstance('api2'),
};

//获取图片验证码接口
export function sendPicYzm(parameter) {
    return apiInstances.api1({
        url: `/v1/captcha/generate/string`,
        method: 'get',
        params: parameter
    })
}

//获取短信验证码 
export function sendSmsCode(parameter) {
    return apiInstances.api1({
        url: `/v1/sms/send`,
        method: 'get',
        params: parameter
    })
}

//手机号注册
export function register(data) {
    return apiInstances.api1({
        url: `/v1/register/phone`,
        method: 'post',
        params: data
    })
}

//用户名密码注册
export function registerPsd(data) {
    return apiInstances.api1({
        url: `/v1/register/nickname`,
        method: 'post',
        params: data
    })
}

//登录 
export function login(data) {
    return apiInstances.api1({
        url: `/v1/login/passwd`,
        method: 'post',
        params: data
    })
}

//短信修改密码 
export function changePassWd(data) {
    return apiInstances.api1({
        url: `/v1/passwd/setBySms`,
        method: 'post',
        params: data
    })
}


//微信登录 
export function wxLogin(parameter) {
    return apiInstances.api1({
        url: '/v1/wechat/web/auth_url',
        method: 'get',
        params: parameter
    })
}

//绑定微信 
export function wxBind(parameter) {
    return apiInstances.api1({
        url: '/v1/wechat/web/bind/auth_url',
        method: 'get',
        params: parameter
    })
}

//QQ登录 
export function QQLogin(parameter) {
    return apiInstances.api1({
        url: '/v1/qq/web/auth_url',
        method: 'get',
        params: parameter
    })
}

//绑定QQ
export function QQBind(parameter) {
    return apiInstances.api1({
        url: '/v1/qq/web/bind/auth_url',
        method: 'get',
        params: parameter
    })
}

//微博登录 
export function WBLogin(parameter) {
    return apiInstances.api1({
        url: '/v1/weibo/web/auth_url',
        method: 'get',
        params: parameter
    })
}

//绑定微博
export function WbBind(parameter) {
    return apiInstances.api1({
        url: '/v1/weibo/web/bind/auth_url',
        method: 'get',
        params: parameter
    })
}

//获取点选验证码
export function getClickCode(parameter) {
    return apiInstances.api1({
        url: '/v1/captcha/click/create',
        method: 'get',
        params: parameter
    })
}

//验证点选验证码
export function checkClickCode(data) {
    return apiInstances.api1({
        url: '/v1/captcha/click/verify',
        method: 'post',
        params: data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

//短信登录
export function smsLogin(data) {
    return apiInstances.api1({
        url: '/v1/login/sms',
        method: 'post',
        params: data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}